export const isEmergencyTelehealthRoomUnavailable = (
	room: string,
	isClinipam: boolean,
): boolean => isClinipam && room.trim().length === 0;
